__webpack_require__.p = "https://status.zdielaj.si/";